@if (ClientVendorSearchModel) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <label>{{ companyTypeSearchText }}</label>
      </div>
    </div>
    <div class="row row-padding-bottom">
      <div class="col">
        <input
          class="form-control"
          [(ngModel)]="ClientVendorSearchModel.legalNameOrDba"
        />
      </div>
    </div>
    @if (showTradeSelection) {
      <div class="row">
        <div class="col">
          <label>Trade</label>
        </div>
      </div>
    }
    @if (showTradeSelection) {
      <div class="row row-padding-bottom">
        <div class="col d-flex flex-column justify-content-end">
          <div ngbDropdown>
            <div id="trade-tagfield-dropdown" class="form-control p-0">
              @for (
                item of ClientVendorSearchModel['TradeCategories'];
                track item;
                let index = $index
              ) {
                <span
                  class="badge bg-primary mx-1"
                  contenteditable="false"
                  tabindex="-1"
                  >{{ item.categoryName }}
                  <i
                    class="bi bi-x-lg cursor-select"
                    (click)="deselectTradeCategory(item, index)"
                  ></i
                ></span>
              }
              @for (
                item of ClientVendorSearchModel['Trades'];
                track item;
                let index = $index
              ) {
                <span
                  class="badge bg-primary mx-1"
                  contenteditable="false"
                  tabindex="-1"
                  >{{ item.name }}
                  <i
                    class="bi bi-x-lg cursor-select"
                    (click)="deselectTrade(item, index)"
                  ></i
                ></span>
              }
              <div
                #TradeCategoryDiv
                (input)="filterTradesAndCategories($event)"
                class="dropdown-toggle-override form-control border-hidden box-shadow-hidden"
                contenteditable="true"
                ngbDropdownToggle
              ></div>
            </div>
            <ul
              class="w-100 vh-25 overflow-y-auto"
              ngbDropdownMenu
              aria-labelledby="trade-tagfield-dropdown"
            >
              @for (item of FilteredTradeCategories; track item) {
                <li>
                  <option
                    class="dropdown-item cursor-select bold"
                    ngbDropdownItem
                    (click)="selectTradeCategory(item)"
                  >
                    {{ item.categoryName }}
                  </option>
                  @for (Trade of item.PrimaryTrades; track Trade) {
                    <option
                      class="dropdown-item cursor-select"
                      ngbDropdownItem
                      (click)="selectTrade(Trade, item)"
                    >
                      {{ Trade.name }}
                    </option>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }
    <div class="row">
      <div class="col">
        <label>Service Address</label>
      </div>
    </div>
    <div class="row row-padding-bottom">
      <div class="col">
        <div ngbDropdown>
          <input
            class="form-control"
            (ngModelChange)="addressSearch($event)"
            (blur)="addressSearchFinished()"
            [(ngModel)]="SearchModelObject.address"
            ngbDropdownToggle
          />
          <ul
            class="w-100 overflow-y-auto"
            ngbDropdownMenu
            [hidden]="SearchedAddresses.length === 0"
          >
            @for (item of SearchedAddresses; track item) {
              <li>
                <option
                  class="dropdown-item cursor-select"
                  ngbDropdownItem
                  (click)="selectAddress(item)"
                >
                  {{ item.name }}
                </option>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col"></div>
      @if (showAdvancedSearch) {
        <div class="col-auto">
          <label class="underline cursor-select" (click)="advancedSearch()"
            >Advanced Search</label
          >
        </div>
      }
      <div class="col-auto">
        <button class="btn btn-primary" (click)="search()">
          <i class="bi bi-search"></i>
          <span class="ps-2">Search</span>
        </button>
      </div>
    </div>
  </div>
}
